// Registration is now implicit: the backend /login endpoint creates a User row
// on first sign-in if firebase_user_id is new. So Register and Sign-in are the
// same single-button Google flow. Re-export SigninForm under the RegisterForm
// name so existing imports across NavBar/HeroSection/FinalCTA keep working.
import {SigninForm} from './SigninForm'

export const RegisterForm = SigninForm
export default RegisterForm
